module.exports = __webpack_public_path__ + "img/feather_upload-cloud.b4cb2320.svg";